/**
 * Represents a gradient stop
 */
export default class GradientStop {
  /**
   * Offset in percentage [0-100]
   */
  offset = 0;
  /**
   * Stop color
   */
  color = '#ffffff';

  /**
   * Stop opacity [0-1]
   */
  opacity = 1;

  /**
   *
   * @param {SVGStopElement|undefined} element
   */
  constructor (element) {
    if (element) {
      this.parseElement(element);
    }
  }

  /**
   * Get data from an SVG element
   * @param {SVGStopElement} element
   */
  parseElement (element) {
    this.offset = parseFloat(element.getAttribute('offset')) || 0;
    this.opacity = parseFloat(element.getAttribute('stop-opacity')) || 0;
    this.color = element.getAttribute('stop-color') || '#000000';
  }

  /**
   * Copy current object to this element
   * @param {SVGStopElement} stopElement
   */
  toElement (stopElement) {
    stopElement.setAttribute('offset', this.offset + '%');
    stopElement.setAttribute('stop-opacity', this.opacity);
    stopElement.setAttribute('stop-color', this.color);
  }

  clone () {
    const copy = new GradientStop();
    copy.offset = this.offset;
    copy.color = this.color;
    copy.opacity = this.opacity;
    return copy;
  }
}
